var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.filterComponent,{tag:"component",attrs:{"filter":_vm.filter,"settings":_vm.settings},on:{"onChange":_vm.changeValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }